export const setCompany = (company) => ({
    type: 'SET_COMPANY',
    company
});